<template>
  <div class="food-item relative-section">
    <div class="image-fit" v-if="item.ImageId">
      <img :src="getImageUri(item.ImageId)" alt />
    </div>
    <div class="info font-bai">
      <h3 class="font-bold">{{ getTranslate(item.Name) }}</h3>
      <div class="des">
        <div class="des-more" v-if="isShowMore" v-html="getTranslate(item.Description)"></div>
        <!-- <div
                    class="des-small"
                    v-if="!isShowMore"
                    v-html="getShortDescription()"
                ></div>
                <div
                    class="des-more"
                    v-if="isShowMore"
                    v-html="getTranslate(item.Description)"
        ></div>-->
      </div>
      <!-- <a @click.prevent="setIsShowMore()" class="show-des">{{
                $t("app.plus d’infos")
      }}</a>-->
    </div>
    <div class="price">
      <b class="font-balo">{{ getPrice() }} {{ currency.symbol }}</b>
      <br />
      <span class="font-bai">{{ $t("app.par personne") }}</span>
      <br />
      <a
        @click.prevent="onAddProductToCart()"
        class="btn add-service"
        :class="{ added: isAddedProduct() }"
      >
        {{
        isAddedProduct() ? $t("app.Supprimer") : $t("app.Ajouter")
        }}
      </a>
    </div>
  </div>
</template>
<script>
import { get, find } from "lodash";
import { CDN_MEWS_MEDIA } from "@/api/config";
import { mapActions, mapState } from "vuex";
export default {
  name: "CartItem",
  props: ["item", "cartProducts", "onGetPricing"],
  data() {
    return {
      isShowMore: true
    };
  },
  computed: {
    ...mapState({
      lang: state => get(state, "app.lang", "fr"),
      currency: state => get(state, "app.currency")
    })
  },
  methods: {
    ...mapActions("cart", ["addProductToCart"]),
    getImageUri(image) {
      return `${CDN_MEWS_MEDIA}/Image/${image}?Mode=Fit&Height=161`;
    },
    getTranslate(object) {
      if (this.lang === "fr" && get(object, "fr-FR")) {
        return get(object, "fr-FR");
      }
      return get(object, "en-US");
    },
    getShortDescription() {
      const des = this.getTranslate(this.item.Description).replace(
        /^(.{50}[^\s]*).*/,
        "$1"
      );
      return des;
    },
    setIsShowMore() {
      this.isShowMore = !this.isShowMore;
    },
    onAddProductToCart() {
      this.addProductToCart(this.item).then(() => this.onGetPricing());
    },
    getPrice() {
      return get(this.item, `Prices.${this.currency.code}`);
    },
    isAddedProduct() {
      return find(this.cartProducts, product => product.Id === this.item.Id);
    }
  }
};
</script>
